
export const url = ""

export const REACT_APP_BASE_URL = "https://www.venuelog.com" // local


export const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://api.venuelog.com/api/";


// 


export const APP_NAME = "VenueLog"
export const APP_DEVELOPED_BY = "IDHAYA CREATIVES"
export const PORT = "3000"
export const MAP_API_KEY = 'AIzaSyBeSEd28jj7f1LpDCjI-ZowhKp1e8z3q4A'



// const API_KEY = 'AIzaSyBeSEd28jj7f1LpDCjI-ZowhKp1e8z3q4A';
// const BASE_URL = 'https://maps.googleapis.com/maps/api/place/textsearch/json';


export const PORTAL_APP_API_BASE_URL ="https://portal.venuelog.com"; // local URL







// export const FIREBASE_CONFIG = {
//     apiKey: "AIzaSyDBAPMio3MXBYssKuLzKCKmOO90ddt3yUU",
//     authDomain: "reactapp-f2994.firebaseapp.com",
//     projectId: "reactapp-f2994",
//     storageBucket: "reactapp-f2994.appspot.com",
//     messagingSenderId: "749956203611",
//     appId: "1:749956203611:web:ca6eaf93d3c76cb3c1ab7e",
//     measurementId: "G-W23VRS0VX8"
//   };



export const FIREBASE_CONFIG  = {
  apiKey: "AIzaSyBMSPjlGn0YwLD1WqYIVSBFDgieGkzwvQ8",
  authDomain: "venuelog-f8c6d.firebaseapp.com",
  projectId: "venuelog-f8c6d",
  storageBucket: "venuelog-f8c6d.appspot.com",
  messagingSenderId: "618113963141",
  appId: "1:618113963141:web:2c11deccaced4f60d3c5ec",
  measurementId: "G-SKS83RBEVZ"
};



